import React from 'react';
import {RaisedButton, Snackbar} from "material-ui";
import {Link, withRouter} from "react-router-dom";
import {trim, get} from "lodash";
import {validateEmail} from "../helpers";
import {createSubscriber} from "../actions/lead";
import {connect} from "react-redux";
import JdData from './JdData'

class JobDescription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }
    state = {
        jdData: [],
        jdId: null
    }

    componentDidMount = async() => {
        const jdId = this.props.match.params.id
        const jdData = JdData.find((data) => data.jd_id === Number(jdId))
        this.setState({
            jdId : Number(jdId),
            jdData : jdData
        })
    }

    onHandleRequestClose = () => {
        this.setState({
            snackOpen: false,
        });
    }
    
    onSubmit = async (e) => {
        e.preventDefault();
        const currentPath = trim(`${window.location.pathname}`,'/')
        const page = currentPath ? currentPath : 'home'
        if (await this.validate()) {
            const body = {
                email: this.state.email,
                subscription_for: page
            };
            this.setState({disabled: true});
            const res = await this.props.createSubscriber(body);
            if (res) {
                this.setState({
                    snackOpen: true,
                    email: '',
                });
            } else {
                alert('Something Went Wrong.');
            }
        }
    }

    onInputChange = (e, key) => {
        this.setState({
            [key]: e.target.value
        });
    }

    validate = async () => {
        let validateFlag = true;
        if (!validateEmail(this.state.email)) {
            validateFlag = false;
            this.setState({
                emailError: alert(`Not a valid Email`)
            });
        } else {
            this.setState({
                emailError: ''
            });
        }
        return validateFlag;
    }

    render() {
        const { jdData } = this.state
        return (
            <div>
                <div className="container career">
                    <div className="job-search">
                        <h4>Job Description</h4>
                    </div>
                    <div className="row job-details align-items-center">
                        <div className="col-md-4">
                            <h5>{`Position : ${get(jdData, 'position', '')}`}</h5>
                        </div>
                        <div className="col-md-8">
                            <p style={{ fontSize: 20 }}>{`Department : ${get(jdData, 'department', '')}`}</p>
                        </div>
                        <div style={{ textAlign: 'justify', paddingLeft: '35px', marginBottom: 'auto', maxWidth: '80%' }}>
                            <div>
                                {/* <p style={{marginBottom: '10px', fontSize: '20px'}}>{`Job Description : ${`Download`}`}</p> */}
                                <p style={{marginBottom: '10px', fontSize: '20px'}}> {`Job Description : `} <a href={get(jdData, 'link', '#')} target="_blank" style={{color: 'blue', textDecoration: 'underline'}}> View Full Description Here </a> </p>
                                <ul style={{paddingLeft: '30px'}}>
                                    <li ><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'bullet_point_1', '')}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'bullet_point_2', '')}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'bullet_point_3', '')}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'bullet_point_4', '')}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'bullet_point_5', '')}`}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div style={{ textAlign: 'justify', paddingLeft: '35px', marginBottom: 'auto', maxWidth: '80%' }}>
                            <div>
                                <p style={{marginBottom: '10px', fontSize: '20px'}}>Key Requirements :</p>
                                <ul style={{paddingLeft: '30px'}}>
                                    <li ><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'key_point_1', '')}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'key_point_2', '')}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${get(jdData, 'key_point_3', '')}`}</span></li>
                                    {/* <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${jdData.key_point_4}`}</span></li>
                                    <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${jdData.key_point_5}`}</span></li> */}
                                </ul>
                            </div>
                        </div>
                        <div style={{ textAlign: 'justify', paddingLeft: '35px', marginBottom: 'auto', maxWidth: '80%' }}>
                            <div style={{ paddingRight: '400px'}}>
                                <p style={{marginBottom: '10px', fontSize: '20px'}}><b>Location(s) :</b>{`${get(jdData, 'locations', '')}`}</p>
                            </div>
                        </div>
                        <div style={{ textAlign: 'justify', paddingLeft: '35px', marginBottom: 'auto', maxWidth: '80%' }}>
                            <div>
                                <p style={{marginBottom: '10px', fontSize: '20px'}}><b>How to Apply -</b> Please share your updated CV at jobs@ascendcap.in. Please include the position title in the subject.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    createSubscriber: body => dispatch(createSubscriber(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(JobDescription))


// WEBPACK FOOTER //
// ./src/components/JobDescription.js